import { useEffect, useState } from "react";
import { ArrowUp } from "lucide-react";

// Floating "back to top" button — appears after scrolling down, bottom-right.
export default function ScrollTopButton() {
  const [show, setShow] = useState(false);
  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 500);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);
  if (!show) return null;
  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="Nach oben scrollen"
      data-testid="scroll-top-btn"
      className="fixed bottom-24 right-5 z-40 w-12 h-12 rounded-full bg-[#0B1F3A] text-white shadow-lg flex items-center justify-center hover:bg-[#0B1F3A]/90 transition-all duration-200 hover:-translate-y-0.5"
    >
      <ArrowUp className="w-5 h-5" />
    </button>
  );
}
